import { render, staticRenderFns } from "./TipoSolicitacao.vue?vue&type=template&id=ff737718"
import script from "./TipoSolicitacao.vue?vue&type=script&lang=js"
export * from "./TipoSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports